import { useTranslation } from 'react-i18next';

import { type NowNextProps, useNowNext } from '../hooks/use-now-next';

/** The plain "Now: … · Next: …" sentence under the phases (Q26). */
export function NowNext({ progress, isGated }: NowNextProps) {
  const { t } = useTranslation('catalog-v2-run');
  const { now, next } = useNowNext({ progress, isGated });
  return (
    <p className="text-sm">
      <span className="text-muted-foreground">{t('phaseTimeline.nowLabel')} </span>
      <span className="text-foreground font-medium">{now}</span>
      {next ? (
        <>
          <span aria-hidden="true" className="text-muted-foreground">
            {' · '}
          </span>
          <span className="text-muted-foreground">{t('phaseTimeline.nextLabel')} </span>
          <span className="text-foreground">{next}</span>
        </>
      ) : null}
    </p>
  );
}
